import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { QuestionManagementService } from 'src/app/Services/question-management/question-management.service';
import { QuestionListComponent } from '../question-list/question-list.component';

@Component({
  selector: 'app-question-external-references-report',
  templateUrl: './question-external-references-report.component.html',
  styleUrls: ['./question-external-references-report.component.css']
})
export class QuestionExternalReferencesReportComponent implements OnInit {
  @ViewChild('questionEditorHost') questionEditorHost?: QuestionListComponent;

  reportRows: any[] = [];
  editorQuestionListResponse: any = null;
  editorSubjectById: any;
  editorQuestionSubjectResponse: any;
  isLoading = false;
  whereToSearchOptions: string[] = [
    'Question',
    'Answer Choice',
    'Answer Notes',
    'Answer Hints'
  ];
  selectedWhereToSearch = 'Question';
  questionId = '';
  searchString = 'src="https://';
  stringToExclude = 'https://latex.codecogs.com';
  subjectList: any[] = [];
  selectedSubjectId: number | null = null;

  constructor(
    private service: QuestionManagementService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadSubjects();
    this.fetchReport();
  }

  loadSubjects(): void {
    const payload: any = {
      currentNodeID: 0,
      screenName: 'SUBJECT BREAKDOWN',
      childRecordStatus: 'ALL',
      CalledFrom: 'Question'
    };

    this.service.getSubjectTree(payload).subscribe(
      (response: any) => {
        this.subjectList = response || [];
      },
      () => {
        this.toastr.error('Failed to load subjects.');
      }
    );
  }

  onSubjectChange(): void {
    this.reportRows = [];
  }

  fetchReport(): void {
    this.isLoading = true;
    const payload = {
      SubjectID: this.selectedSubjectId ? Number(this.selectedSubjectId) : null,
      WhereToSearch: this.selectedWhereToSearch,
      QuestionID: this.questionId?.trim() || null,
      SearchString: this.searchString,
      StringToExclude: this.stringToExclude
    };

    this.service.GetSearchStringInQuestion(payload).subscribe(
      (response: any) => {
        this.isLoading = false;
        const apiData = response?.data || response?.Data || [];
        this.reportRows = Array.isArray(apiData) ? apiData : [];

        const isFailed = response?.status === false || response?.Status === false;
        if (isFailed) {
          this.toastr.error(response?.message || response?.Message || 'Failed to fetch report');
        }
      },
      () => {
        this.isLoading = false;
        this.toastr.error('Failed to fetch report');
      }
    );
  }

  onWhereToSearchChange(): void {
    this.reportRows = [];
  }

  clearFilters(): void {
    this.selectedWhereToSearch = 'Question';
    this.questionId = '';
    this.selectedSubjectId = null;
    this.reportRows = [];
  }

  openQuestionEditor(row: any, event?: Event): void {
    event?.preventDefault();

    const questionId = row?.Question_ID || row?.Question_Id;
    if (!questionId) {
      this.toastr.error('Question ID is not available.');
      return;
    }

    this.service.GetQuestionByID({ QuestionID: questionId }).subscribe(
      (questionResponse: any) => {
        const questionDetails = questionResponse?.result?.[0];
        const subjectId = questionDetails?.Subject_Id || questionDetails?.Subject_ID;

        if (!questionDetails || !subjectId) {
          this.toastr.error('Unable to load question details.');
          return;
        }

        this.service
          .getsubjectById({ CurrentNodeSubjectID: Number(subjectId) })
          .subscribe(
            (subjectResponse: any) => {
              this.editorSubjectById = subjectResponse;
              this.service
                .GetQuestionSubject({ SubjectID: Number(this.editorSubjectById?.Subject_Id) })
                .subscribe(
                  (subjectQuestionResponse: any) => {
                    this.editorQuestionSubjectResponse =
                      subjectQuestionResponse?.SubjectExistsInd;

                    if (!this.questionEditorHost) {
                      this.toastr.error('Question editor could not be opened.');
                      return;
                    }

                    this.questionEditorHost.subjectById = this.editorSubjectById;
                    this.questionEditorHost.questionsubjectresponse =
                      this.editorQuestionSubjectResponse;
                    this.questionEditorHost.EditQuestion(questionDetails);
                  },
                  () => {
                    this.toastr.error('Unable to load subject questions.');
                  }
                );
            },
            () => {
              this.toastr.error('Unable to load subject details.');
            }
          );
      },
      () => {
        this.toastr.error('Unable to load question details.');
      }
    );
  }
}
